import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DealerPortalService } from 'src/app/services/dealerPortal.service';
import { Subscription } from 'rxjs';
import { CustomerService } from 'src/app/services/customer.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-marketing-activity-material',
  templateUrl: './marketing-activity-material.component.html',
  styleUrls: ['./marketing-activity-material.component.less']
})
export class MarketingActivityMaterialComponent implements OnInit {
  @Input() tabSelectedIndex: number | undefined;
  isResetting = false;
  firstLoading = true;
  searchMaterialFormData!: FormGroup;
  ranges: any;
  loading = false;
  pageNum = 1;
  totalNum = 4;
  date = null;
  codeTypeList: any = [];
  // approvalStatusList: any = ['审批中', '审批通过', '审批拒绝', '撤回'];
  approvalStatusList: any = ['审批中', '已撤回', '审批通过'];
  activityList: any = [];
  productLineList: any = [];
  private customerSubscription: Subscription | undefined;

  constructor(private fb: FormBuilder,
    private customerService: CustomerService,
    private router: Router,
    private dealerPortalService: DealerPortalService) { }

  ngOnInit() {
    this.initData().then(() => {
      this.firstLoading = false;
    })
    this.customerSubscription = this.customerService.selectedCustomer$.subscribe(() => {
      if (!this.firstLoading && this.router.url.includes('/marketing-activity') && this.tabSelectedIndex === 1) {
        this.initData();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.customerSubscription) {
      this.customerSubscription.unsubscribe();
    }
  }

  initData(): Promise<void> {
    return new Promise((resolve) => {
      this.searchMaterialFormData = this.fb.group({
        activityRequestNo: "",
        verificationCode: "",
        productLine: "",
        approvalStatus: "",
        yearRange: null,
      });
      this.getMarketingProcessMaterial();
      this.getFeeFilterList()
      resolve();
    })
  }

  onPageIndexChange(pageIndex: number) {
    this.pageNum = pageIndex;
    this.getMarketingProcessMaterial()
  }

  filterMarketingProcessMaterial() {
    this.pageNum = 1;
    this.getMarketingProcessMaterial();
  }

  getMarketingProcessMaterial() {
    if (this.isResetting) return;
    const filters = this.searchMaterialFormData.value;
    let startYear = '';
    let endYear = '';
    if (filters.yearRange && filters.yearRange.length > 0) {
      const [start, end] = filters.yearRange;
      startYear = new Date(start).getFullYear().toString();
      endYear = new Date(end).getFullYear().toString();
    }
    const param = {
      pageNum: this.pageNum,
      pageSize: 4,
      activityRequestNo: filters.activityRequestNo,
      verificationCode: filters.verificationCode,
      productLine: filters.productLine,
      approvalStatus: filters.approvalStatus,
      startYear: startYear,
      endYear: endYear,
    }
    this.loading = true;
    this.dealerPortalService.getMarketingProcessMaterial(param).subscribe(result => {
      const { rtnCode, rtnData } = result;
      this.activityList = rtnData.records;
      this.pageNum = rtnData.current;
      this.totalNum = rtnData.total;
      this.loading = false;
    })
  }


  getFeeFilterList() {
    this.dealerPortalService.getMaterialFilterList().subscribe(result => {
      const { rtnCode, rtnData } = result;
      this.productLineList = rtnData.productLines;
    })
  }

  onButtonClick(btn: any, item: any) {
    console.log(`Clicked ${btn.label} for`, item);
  }

  formatMoney(value: any, decimals = 2): string {
    if (value === null || value === undefined || value === '' || value === 0) {
      return '-';
    }

    const num = Number(value);
    if (isNaN(num)) {
      return String(value);
    }

    return num
      .toFixed(decimals)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  getColorByValue(progress: number): string {
    return (progress * 100) >= 90 ? '#9E2896' : '#007BC0';
  }
  formatPercent = (percent: number | string): string => {
    const num = Number(percent);
    return `${num.toFixed(1)}%`;
  };



  changeKeywords() {
    this.searchMaterialFormData.get('keywords')?.setValue('');
  }
  onInputEnter(event: any): void {
    event.preventDefault();
  }
  handleChange(e?: Event): void {
    // if (!this.isReset) {
    //   this.pagination.pageIndex = 1;
    //   setTimeout(() => {
    //     this.getList();
    //   }, 0);
    // }
  }

  clear(): void {
    this.isResetting = true;
    this.searchMaterialFormData.reset();
    this.isResetting = false;
    this.getMarketingProcessMaterial();
  }
}
